import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, Button, Typography, Stack, IconButton, Tooltip, TextField} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import caseNotiFicationEnum from "../../enums/CaseNotiFicationEnum";
import DeclineRequestStatusEnum from "../../enums/declineRequestStatusEnum";

const CaseCancelForBuilding = ({onFileAdded, onCaseStatusChange}) => {
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [declineReasonFromUser, setDeclineReasonFromUser] = useState('');

    useEffect(() => {
        setDisabled(!file || declineReasonFromUser === '');
    }, [file, declineReasonFromUser]);


    const sendNotification = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddCaseNotificationRangeByCaseId`, {
                caseId: parseInt(caseId, 10),
                action: caseNotiFicationEnum.requestToCancelCase.id
            });

        } catch (error) {
        }
    };

    const updateDeclinationReason = async (caseId) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseDeclineRequestStatusAnddeclineReasonFromUser`, {
                caseID: parseInt(caseId, 10),
                declineReasonFromUser: declineReasonFromUser,
                declineREquestStatus: DeclineRequestStatusEnum.declineRequested
            });

        } catch (error) {
        }
    };

    const handleOpenConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const handleCloseConfirmationModal = () => {
        setIsConfirmationModalOpen(false);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        resetFile();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type !== 'application/pdf') {
                setErrorMessage('არასწორი ფორმატი! ატვირთეთ PDF ფაილი!');
                resetFile();
                return;
            }

            const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB in bytes
            if (file.size > maxSizeInBytes) {
                setErrorMessage('ფაილის ზომა აღემატება 10 მეგაბაიტს!');
                resetFile();
                return;
            }

            setErrorMessage('');
            setFileName(file.name);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setFile(reader.result.replace(/^data:.+;base64,/, ''));
            };
        }
    };


    const handleSubmit = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseID = urlParams.get('id');
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`;
        const data = {
            caseID: parseInt(caseID),
            name: "განაცხადის განუხილველად დატოვების მოთხოვნა",
            ext: "pdf",
            mainInfo: "",
            additionalInfo: "",
            file: file,
            shared: true,
            blank: false,
            documentType: 0,
            internal: false,
            status: 3,
            decline: CaseFileDeclined.RequireCaseCancellationBuilding,
            fileTypeId: 23,
            declinedInternalStatus: 0,
            casefileNumber: "/1"
        };

        try {
            await axios.post(apiUrl, data);
            await sendNotification(caseID)
            await updateDeclinationReason(caseID)
            resetFile();
            handleClose();
            onCaseStatusChange();
            onFileAdded();
        } catch (error) {
        }
    };

    const handlePreview = () => {
        if (!file) return;
        const byteCharacters = atob(file);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const fileBlob = new Blob([byteArray], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(fileBlob);
        window.open(fileURL, '_blank');
    };

    const resetFile = () => {
        setFile(null);
        setFileName('');
        document.getElementById('contained-button-file').value = '';
    };

    return (
        <div>
            <button className={"document-buttonn-red"} onClick={handleClickOpen}>
                განაცხადის განუხილველად დატოვების მოთხოვნა
            </button>
            <Dialog style={{zIndex: 34}} fullWidth maxWidth="sm" open={open} onClose={handleClose}>
                <h2 style={{textAlign: "center"}}>განაცხადის განუხილველად დატოვების მოთხოვნა</h2>
                <DialogContent>
                    <Stack direction="column" spacing={2}>
                        <TextField
                            margin="dense"
                            label="კომენტარი"
                            type="text"
                            fullWidth
                            multiline
                            rows={8}
                            variant="outlined"
                            name="title"
                            value={declineReasonFromUser}
                            onChange={(e) => setDeclineReasonFromUser(e.target.value)}
                        />
                        <input
                            accept="application/pdf"
                            style={{display: 'none'}}
                            id="contained-button-file"
                            type="file"
                            onChange={handleFileChange}
                        />
                        <label htmlFor="contained-button-file">
                            <Button fullWidth variant="contained" component="span">
                                ფაილის ატვირთვა (pdf, მაქს. 10 mb.)
                            </Button>
                        </label>
                        {fileName && (
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="body1">{fileName}</Typography>
                                <Tooltip title={"ფაილის ნახვა"}>
                                    <div>
                                        <IconButton aria-label="preview" onClick={handlePreview}>
                                            <VisibilityIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                                <Tooltip title={"ფაილის წაშლა"}>
                                    <div>
                                        <IconButton aria-label="delete" onClick={resetFile}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            </Stack>
                        )}

                        {errorMessage && (
                            <Typography variant="body2" color="error">
                                {errorMessage}
                            </Typography>
                        )}
                        <Tooltip title={!file ? "გთხოვთ, ატვირთოთ დოკუმენტი" : declineReasonFromUser === "" ? "გთხოვთ, ჩაწეროთ კომენტარი" : ""}>
                        <span style={{cursor: disabled ? "not-allowed" : "pointer", width: '100%'}}>
                        <Button fullWidth variant="contained" color="secondary" onClick={handleOpenConfirmationModal}
                                disabled={disabled}>
                            გაგზავნა
                        </Button>
                            </span>
                        </Tooltip>
                    </Stack>
                </DialogContent>
            </Dialog>
            <ConfirmationModal
                isOpen={isConfirmationModalOpen}
                onRequestClose={handleCloseConfirmationModal}
                onConfirm={handleSubmit}
            />
        </div>
    );
};

export default CaseCancelForBuilding;
